import React from "react";


import parseHTML from "html-react-parser";


import { Col } from "react-bootstrap";


import "./index.scss";


import { CardTypesType } from "@Components/Elements";


type CardMainTitleComponentProps = {
    title: string;
    cardType?: CardTypesType;
    size?: 'md' | 'lg';
};


export const CardMainTitleComponent:React.FC<CardMainTitleComponentProps> = ({
    title, cardType = 'default', size = 'md'
}) => {

    if (!title) {
        return null;
    }

    return (
        <Col xs={12} className={`card-component__main-title ${cardType}-card-component__main-title card-component__main-title--${size}`}>
            <span>{parseHTML(title)}</span>
        </Col>
    );

};


export default CardMainTitleComponent;
